<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  amount: number | null;
  selectedNisab: "silver" | "gold";
  nisabLabel: string;
  silverLabel: string;
  goldLabel: string;
  nisabSwitch: string;
  nisabSwitchBack: string;
  educationalLine: string;
  formattedCurrentNisab: string;
}>();

const emit = defineEmits<{
  (e: "toggle-nisab"): void;
}>();

const showDetails = ref(false);
</script>

<template>
  <section
    v-if="amount && amount > 0"
    class="rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 px-4 py-3 space-y-1.5"
  >
    <div class="flex items-center justify-between gap-3">
      <div class="text-sm text-gray-700 dark:text-gray-300">
        {{ nisabLabel }} (
        <span class="font-medium">
          {{ selectedNisab === "silver" ? silverLabel : goldLabel }}
        </span>
        )
      </div>
      <transition name="nisab-fade" mode="out-in">
        <div
          :key="selectedNisab"
          class="text-base font-semibold text-gray-900 dark:text-gray-100 tabular-nums"
        >
          Rs {{ formattedCurrentNisab }}
        </div>
      </transition>
    </div>

    <div class="flex items-center justify-between gap-3">
      <button
        class="text-sm text-gray-600 dark:text-gray-400 hover:underline underline-offset-2"
        @click="emit('toggle-nisab')"
      >
        {{
          selectedNisab === "silver"
            ? nisabSwitch
            : nisabSwitchBack
        }}
      </button>
      <button
        class="text-xs text-gray-500 dark:text-gray-400 hover:underline underline-offset-2"
        @click="showDetails = !showDetails"
      >
        {{ showDetails ? "Hide details" : "Details" }}
      </button>
    </div>

    <transition name="nisab-fade">
      <p
        v-if="showDetails"
        class="text-xs text-gray-500 dark:text-gray-400 leading-relaxed"
      >
        {{ educationalLine }}
      </p>
    </transition>
  </section>
</template>

<style scoped>
.nisab-fade-enter-active,
.nisab-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.nisab-fade-enter-from,
.nisab-fade-leave-to {
  opacity: 0;
  transform: translateY(2px);
}
</style>
